import FormSectionTitle from '../../../../../elements/FormSectionTitle'
import React, { Component, Fragment } from 'react'
import { Col, Form, InputNumber, Row, Select } from 'antd'
import Suppliers from '../../../../../api/Purchase/Suppliers'
import CurrencySelect from '../../../../../elements/Select/Currency'
import { get, isEmpty } from 'lodash'
import { compose } from 'recompose'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import style from '../../../../../components/Sales/Client/Contract/Form/style.css'

const FormItem = Form.Item
const { Option } = Select

const BillingType = compose(
  withSelectFetch({ dropdown: 'supplier', name: 'billing' }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort,
)(CustomSelect)

const PaymentTerms = compose(
  withSelectFetch({ dropdown: 'supplier', name: 'terms' }),
  withSpinning,
  withSubDropdown({ name: 'payment' }),
  withSort,
)(CustomSelect)

class Payment extends Component {
  constructor (props) {
    super(props)
    this.api = new Suppliers()
    this.key = props.supplier._key
    this.owner = props.supplier.owner.replace('members/', '')
    const company = get(props.contract, 'company._id')
    const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)

    this.BankSelectCompany = compose(
      withUrlFetch({
        name: 'banks',
        url: url,
        cache: false,
        forceFetch: true,
      }),
      withSpinning,
      withSort,
    )(CustomSelect)

    this.BankSelectVendor = compose(
      withUrlFetch({
        name: 'banks',
        url: `banks/?owner=members/${this.owner}`,
        cache: false,
        forceFetch: true,
      }),
      withSpinning,
      withSort,
    )(CustomSelect)
  }

  render () {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { contract } = this.props
    const { BankSelectCompany, BankSelectVendor } = this

    return (
      <Form layout="horizontal">
        <Row>
          <h3 className={style.formSubtitle}>DEFAULT BILLING</h3>
          <Col span={12}>
            <FormItem label="Billing Type" {...formItemLayout}>
              {getFieldDecorator('billing.type', {
                initialValue: get(contract, 'billing.type'),
                rules: [
                  {
                    required: true,
                    message: 'Billing Type can\'t be empty ',
                  },
                ],
              })(<BillingType placeholder="Billing Type"/>)}
            </FormItem>
          </Col>
          {this.props.form.getFieldValue('billing.type') === 'prePaid' && (
            <Fragment>
              <Col span={12}>
                <Form.Item label="Amount" {...formItemLayout}>
                  {getFieldDecorator('billing.amount', {
                    initialValue: get(contract, 'billing.amount'),
                  })(<InputNumber placeholder="Amount" style={{ width: '100%' }}/>)}
                </Form.Item>
              </Col>
            </Fragment>
          )}
          <Col span={12}/>
        </Row>
        <FormSectionTitle title={'DEFAULT PAYMENT TERMS'}/>
        <Row>
          <Col span={12}>
            <FormItem label="Payment Terms" {...formItemLayout}>
              {getFieldDecorator('pay.terms', {
                initialValue: get(contract, 'pay.terms'),
                rules: [
                  {
                    required: true,
                    message: 'Payment Terms can\'t be empty ',
                  },
                ],
              })(<PaymentTerms placeholder="Payment Terms"/>)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Pay Currency" {...formItemLayout}>
              {getFieldDecorator('pay.currency', {
                initialValue: get(contract, 'pay.currency'),
                rules: [
                  {
                    required: true,
                    message: 'Pay Currency can\'t be empty ',
                  },
                ],
              })(<CurrencySelect/>)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Company Bank Account" {...formItemLayout}>
              {getFieldDecorator('companyBank._id', {
                initialValue: get(contract, 'companyBank._id'),
                rules: [
                  {
                    required: true,
                    message: 'Bank can\'t be empty ',
                  },
                ],
              })(
                <BankSelectCompany
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  placeholder={'Bank Account'}
                />,
              )}
            </FormItem>
          </Col>
          {getFieldValue('billing.type') !== 'online' && (
            <Col span={12}>
              <FormItem label="Supplier Bank Account" {...formItemLayout}>
                {getFieldDecorator('VendorBank._id', {
                  initialValue: get(contract, 'VendorBank._id'),
                  rules: [
                    {
                      required: true,
                      message: 'Bank can\'t be empty ',
                    },
                  ],
                })(
                  <BankSelectVendor
                    keyAtr={'_id'}
                    valueAtr={'nickname'}
                    placeholder={'Bank Account'}
                  />,
                )}
              </FormItem>
            </Col>
          )}
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Payment)
